import { Component, ChangeDetectionStrategy, Input, HostBinding } from '@angular/core';
import { Store } from '@ngxs/store';
import { AccountState } from '@shared/states/account.state';

@Component({
  selector: 'brand-name',
  templateUrl: './brand-name.component.html',
  styleUrls: ['./brand-name.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BrandName {
  @Input()
  @HostBinding('class')
  class: string;

  constructor(private store: Store) {}

  branding() {
    const branding = this.store.selectSnapshot(AccountState.parentBranding);
    // console.warn('<brand-name>', branding);
    return branding;
  }
}
